import cn from 'classnames';
import { useEffect, type FC } from 'react';
import { useScrollToTop } from '@shared/hooks/useScrollToTop';
import { Blank, Loader, ProductCard } from 'library/components/shop';
import useProducts from 'library/hooks/shop/useProducts';
import * as st from './styles.module.scss';

export const Products: FC = () => {
  useScrollToTop();

  const { products, lastElement, isLoading, search } = useProducts();

  return isLoading ? (
    <Loader text="Загрузка..." />
  ) : (
    <ul className={cn(st.products, products.length === 0 ? st.blank : st.cards)}>
      {products.length !== 0 &&
        products.map((product) => <ProductCard product={product} key={product.id} />)}

      {!isLoading && products.length === 0 && search && <Blank text="Товары не найдены" />}

      <div ref={lastElement} />
    </ul>
  );
};
